import React, { useState, useRef, useEffect } from "react";
import SearchGreyIcon from "../../../assets/images/SearchGreyIcon.svg";
import rightAnglePath from "../../../assets/images/rightAnglePath.svg";
import "./SearchVerifiedTrade.css";
import useApi from "../../../helpers/apiHelper/requestHelper";
import { useNavigate } from "react-router-dom";

const SearchVerifiedTrade = () => {
  const api = useApi();
  const [show, setShow] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);
  const debounceTimeout = useRef(null);
  const navigate = useNavigate();
 
  const handleTradeView = async (id) => {
    await api("post", "/blockchain/update-search-count");
    // navigate(`verifymytrades/${id}`)
    setInputValue("");
    navigate(`/verifymytrades/${id}`);
  };

  useEffect(() => {
    if (!inputValue) {
      setShow(false);
      setOptions([]);
      return;
    }
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      api("get", `/blockchain/search?q=${encodeURIComponent(inputValue)}`).then(
        (res) => {
          if (!res.status) {
            return;
          }

          setOptions(res.data.results);
          setShow(true);
        }
      );
    }, 400); // 400ms debounce
    return () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
    };
  }, [inputValue]);
  return (
    <div className="custom-container publicSearch">
      <div className="searchVerifiedTradeWrap">
        <div className="contentWrap">
          <h4 className="title">Search for a verified trade</h4>
          <p className="desc">If we've verified a trade you'll find it here</p>
        </div>
        <div className="searchBarWrap position-relative">
          <input
            type="text"
            className="form-control"
            placeholder="Search for a Blockchain Transaction ID or trader name"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
          {!show && (
            <span className="searchIconWrap position-absolute  translate-middle-y">
              <img src={SearchGreyIcon} alt="SearchGreyIcon" />
            </span>
          )}
          {show && options.length > 0 && (
            <div className="searchOptionsWrap">
              {options.map((data, index) => (
                <div
                  onClick={() => handleTradeView(data.blockChainId)}
                  className="searchOptionsContent"
                  key={index}
                >
                  <div className="searchOptions">
                    <p className="linkDetail">{data.blockChainId || data}</p>
                    <p>Click to see details</p>
                  </div>
                  <img src={rightAnglePath} alt="arrow" />
                </div>
              ))}
            </div>
          )}

          {show && options.length === 0 && (
            <div className="searchOptionsWrap">
              <div className="noDataText">
                <p className="mb-2">No results {":("}</p>
                <p>Please double check Blockchain ID or the trader name</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchVerifiedTrade;
